module.exports = __webpack_public_path__ + "img/reference19.f09e9241.jpg";